import { PackageNamespace } from '@tablekit/package-namespace';
var spinnerThemeNamespace = PackageNamespace.Spinner;
var spinnerClassicTheme = {
  fillColor: function fillColor(_ref) {
    var theme = _ref.theme;
    return theme.colors.primary2;
  }
};
var spinnerDarkTheme = spinnerClassicTheme;
export { spinnerClassicTheme, spinnerDarkTheme, spinnerThemeNamespace };
